import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="min-h-screen px-4 py-16 bg-stone-50" data-testid="admin-login-page">
      <div className="max-w-5xl mx-auto grid lg:grid-cols-[1.2fr_0.8fr] gap-10 items-center">
        <div className="space-y-6">
          <div className="inline-flex items-center rounded-full px-4 py-2 text-sm font-semibold" style={{ backgroundColor: '#53a5ca20', color: '#53a5ca' }}>
            NAIWA Daughters Admin Portal
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" style={{ color: '#7e2f22' }}>
            Protected access for registrations, messages, and community operations.
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl">
            Sign in with the approved NAIWA Daughters Google account to review tryout pre-registrations, contact messages, membership applications, and support inquiries.
          </p>
        </div>

        <Card className="border-0 shadow-2xl overflow-hidden">
          <CardContent className="p-8 space-y-6">
            <div className="space-y-2">
              <h2 className="text-2xl font-bold" style={{ color: '#7e2f22' }}>Sign in</h2>
              <p className="text-sm text-gray-600">Access is restricted to the approved admin email.</p>
            </div>
            <Button onClick={login} className="w-full text-white h-12" style={{ backgroundColor: '#53a5ca' }} data-testid="admin-google-login-button">
              Continue with Google
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}